<style lang="scss">
.handle-block,
.handle-lesson,
.handle-task {
  cursor: grabbing;
  opacity: 0.4;
}
.handle-lesson,
.lesson-tooltip {
  color: rgb(17, 205, 239);
}
.lesson-tooltip {
  color: rgba(17, 205, 239, 0.53);
}

.handle-task {
  color: #ff5725;
}
.task-tooltip {
  color: rgba(185, 62, 26, 0.64);
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.list-group-item.draggable {
  padding: 0;
  background: transparent;
  border-radius: 0 !important;
  &:first-child {
    border-top: 1px solid #e9ecef !important;
  }

  &.lesson-group {
    background: rgba(255, 255, 255, 0.3);
    &.lesson-in-progress {
      background: #d0e1ff3d;
    }
    &.lesson-done {
      background: #d0fbd09c;
    }
    .row.lesson-item.align-items-center {
      padding: 0.25rem 1rem;
      h5 {
        font-weight: 300;
      }
      h4 {
        font-weight: 500;
        line-height: 1.75rem;
      }
    }
  }

  &.task-group {
    background: rgba(255, 255, 255, 0.6);
    .row.task-item.align-items-center {
      padding: 0.5rem 1rem;
      align-items: center !important;
      h5 {
        font-weight: 300;
      }
      h4 {
        font-weight: 500;
      }
    }
  }

  & > div.row {
    padding: 1rem;

    .col-status {
      min-width: 7rem;

      i {
        padding: 0 0.25rem;
      }
    }
  }
}

a:not([href]).dropdown-item {
  cursor: pointer;
}

.tags-input__wrapper {
  height: auto;
}
</style>

<template>
  <div>
    <draggable
      v-bind="dragOptions"
      tag="ul"
      class="list-group list-group-flush block-list"
      :list="list"
      :value="value"
      handle=".handle-block"
      @input="emitter"
      :move="onMove"
    >
      <transition-group type="transition" name="flip-list">
        <li
          class="list-group-item draggable block-group"
          :key="block.id"
          v-for="(block, key) in realValue"
        >
          <div class="row align-items-center">
            <div class="col-auto">
              <i v-if="!readOnly" class="fa fa-align-justify handle-block"></i>
            </div>
            <div class="col ml-2">
              <h4 class="mb-0">
                <span v-if="readOnly">{{ block.title }}</span>
                <router-link v-else :to="editUrl(block.id)">{{ block.title }}</router-link>
              </h4>
              <p class="mt-2" v-if="readOnly">{{ block.description }}</p>
            </div>
            <div v-if="!readOnly" class="col-auto pr-2 col-status">
              <el-tooltip
                v-if="block.isVisible"
                :content="$t('visible for users')"
                placement="left"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
              </el-tooltip>
            </div>
            <div v-if="!readOnly" class="col-auto col-actions">
              <el-dropdown trigger="click" class="dropdown">
                <span class="btn btn-flat">
                  <i class="fas fa-ellipsis-v"></i>
                </span>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <router-link
                    class="dropdown-item"
                    :to="{name: 'learn-course-content', params: {...$route.params, blockId: block.id}}"
                  >
                    <i class="fas fa-eye"></i>Посмотреть как студент
                  </router-link>
                  <a class="dropdown-item text-warning" @click="confirmDelete(block.id)">
                    <i class="fas fa-trash-alt"></i>Удалить
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <lesson-draggable-list
            v-if="block.lessons"
            @input="childEmitter"
            :blockId="block.id"
            :read-only="readOnly"
            :mode="mode"
            v-model="block.lessons"
          ></lesson-draggable-list>
        </li>
        <li v-if="!readOnly" class="list-group-item draggable block-group" :key="-1">
          <div class="row align-items-center">
            <div class="col">
              <router-link :to="addUrl">
                <button type="button" class="btn btn-sm btn-primary">{{ $t('Add new block') }}</button>
              </router-link>
            </div>
          </div>
        </li>
      </transition-group>
    </draggable>
    <modal-delete-confirmation
      ref="block-delete-confirmation"
      v-if="!readOnly"
      v-model="showModal"
      :text="textModal"
      :id="idModal"
      @confirmed="onDeleteBlock"
    ></modal-delete-confirmation>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import LessonDraggableList from "./LessonDraggableList";
import { Tooltip, DropdownMenu, Dropdown } from "element-ui";
import ModalDeleteConfirmation from "../Modals/ModalDeleteConfirmation";
import { createNamespacedHelpers } from "vuex";
import { DeleteConfirmation } from "../../mixins/DeleteConfirmation";

const { mapActions } = createNamespacedHelpers("course/block");

export default {
  name: "BlockDraggableList",
  mixins: [DeleteConfirmation],
  methods: {
    emitter(value) {
      this.$emit("input", value);
    },
    childEmitter() {
      this.$emit("input", this.value);
    },
    onMove(evt) {
      return evt.related.classList.contains("block-group");
    },
    ...mapActions({
      deleteBlock: "deleteBlock",
    }),

    async onDeleteBlock(id) {
      await this.deleteBlock({
        urlParams: { courseId: this.$route.params.courseId, blockId: id },
      });
      await this.$store.dispatch("course/content/load", {
        urlParams: this.$route.params,
      });
    },
  },
  components: {
    ModalDeleteConfirmation,
    [Tooltip.name]: Tooltip,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    LessonDraggableList,
    draggable,
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    textModal() {
      return this.$i18n.t("modal.blockDelete.text", this.idModal);
    },
    realValue() {
      return this.value ? this.value : this.list;
    },
    addUrl() {
      return {
        name: "block-add",
        params: { courseId: this.$route.params.courseId },
      };
    },
    editUrl() {
      return (id) => {
        return {
          name: "block-edit",
          params: {
            courseId: this.$route.params.courseId,
            blockId: id,
          },
        };
      };
    },
    publicPageUrl() {
      return (id) => {
        return {
          name: "learn-block-index",
          params: {
            courseId: this.$route.params.courseId,
            blockId: id,
          },
        };
      };
    },
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null,
    },
    list: {
      required: false,
      type: Array,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "author",
    },
  },
};
</script>
